import { useContext } from 'react'
import { AuthContext } from '@/context/AuthContext'
import type { AuthContextValue } from '@/types'

/**
 * Convenience hook to access the authentication context.
 *
 * Must be used inside an <AuthProvider> tree. Throws a descriptive error
 * if called outside of one so bugs are caught early during development.
 *
 * @example
 *   const { user, login, logout, isAuthenticated } = useAuth()
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext)

  if (context === null) {
    throw new Error(
      'useAuth() must be used within an <AuthProvider>. ' +
        'Make sure the component calling useAuth() is a descendant of <AuthProvider>.',
    )
  }

  return context
}

export default useAuth
